<!--
 * @Description:
 * @Author: dingyajun
 * @Date: 2022-07-22 17:45:35
 * @LastEditTime: 2022-08-03 17:08:30
 * @LastEditors: dingyajun
 * @Reference:
-->
<template>
  <div>
    <a-modal
      :visible="visible"
      title="隐藏小组列表"
      :width="hideModalWidth"
      centered
      wrap-class-name="hide-group-modal"
      ok-text="关闭"
      :destroy-on-close="true"
      :confirm-loading="confirmLoading"
      :closable="true"
      :z-index="100"
      :footer="null"
      @cancel="handleCancel"
      @ok="handleCancel"
    >
      <!-- 搜索 -->
      <div class="table-filter">
        <div class="filter">
          <a-input
            placeholder="搜索小组名称"
            style="width: 130px"
            class="filter-selection"
            allow-clear
            v-model="searchGroupName"
          />
          <a-input
            placeholder="学习机课程名称"
            style="width: 144px"
            class="filter-selection"
            allow-clear
            v-model="searchItvCourseName"
          />
          <template>
            <span class="filter-selection">学年学期</span>
            <YearSemesterSelect class="mr4" ref="yearAndSemesterModle" @updateYearAndSemester="updateYearAndSemester" />
          </template>
          <template>
            <span class="filter-selection">期次</span>
            <a-select class="select mr4" :value="activePeriod" @change="(val) => selectionChange(val, 'Period')">
              <a-select-option :value="item.id" v-for="item in periodList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <span class="filter-selection">周期   </span>
            <a-select class="select mr4" v-model="activeClassCycle" @change="(val) => selectionChange(val, 'ClassCycle')">
              <a-select-option :value="item.id" v-for="item in classCycleList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <span class="filter-selection">时段</span>
            <a-select class="select mr4" v-model="activeTimeInterval" @change="(val) => selectionChange(val, 'TimeInterval')">
              <a-select-option :value="item.id" v-for="item in timeIntervalList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <!-- <a-input
          placeholder="学生姓名/手机号"
          style="width: 146px"
          class="filter-selection"
          allow-clear
          v-model="searchStuKeyword"
        /> -->
          <template>
            <a-button type="primary" class="mr4" @click="doSearch">
              搜索
            </a-button>
          </template>
          <template>
            <a-button @click="doReset" class="ant-btn-secondary">
              重置
            </a-button>
          </template>
        </div>
      </div>

      <!-- 学生列表 -->
      <a-table
        :table-layout="auto"
        :loading="loading"
        :columns="columns"
        :data-source="groupList"
        :pagination="false"
        :scroll="scroll"
        row-key="id"
      >
        <!-- <span slot="index" slot-scope="text">{{ text }}</span> -->
        <span slot="groupName" class="plan-name text-limit" slot-scope="text, record" :title="text">
          <a-tooltip placement="top">
            <template slot="title">
              小组ID: {{ record.id }}
            </template>
            {{ text }}
          </a-tooltip>
        </span>
        <span slot="studentNum" class="text-num" slot-scope="text">{{ text }}</span>

        <span slot="courseTime" class="title-dom">
          时间
        </span>
        <span slot="openTime" slot-scope="text, record">
          {{ record | formatTimeStr }}
        </span>
        <div slot="itvCourseName" slot-scope="text, record" :title="text" class="text-itv-name">
          <span class="text-limit">{{ text }}</span>
          <i v-if="record.experience === 1">体验课</i>
        </div>
        <span slot="semester" slot-scope="text, record">
          {{ record.year > 0 && record.semester ? (record.year + ' ' + record.semester) : '--' }}
        </span>
        <span slot="periodStr" slot-scope="text, record">{{ record.periodStr || '--' }}</span>
        <span slot="classCycleStr" slot-scope="text, record" :title="text">{{ record.classCycleStr || '--' }}</span>
        <span slot="timeIntervalStr" slot-scope="text, record" :title="text">{{ record.timeIntervalStr || '--' }}</span>
        <!-- 操作按钮 -->
        <span slot="actions" slot-scope="text, record">
          <a-button type="t-link" @click="handleShowGroup(record)">
            恢复
          </a-button>
        </span>
      </a-table>
      <!-- 翻页 -->
      <div class="pagination">
        <a-pagination
          v-show="pagination.total > 0"
          v-model="pagination.current"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          @change="handleChangePageNum"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import YearSemesterSelect from '@/components/YearSemesterSelect.vue'
import mixins from '@/utils/mixins'
import moment from 'moment'

// 小组列表
const columns = [
  {
    dataIndex: 'groupName',
    key: 'groupName',
    title: '小组名称',
    scopedSlots: { customRender: 'groupName' },
    width: 100
  },
  {
    dataIndex: 'studentNum',
    key: 'studentNum',
    title: '人数',
    scopedSlots: { customRender: 'studentNum' },
    width: 50
  },
  {
    slots: { title: 'courseTime' },
    scopedSlots: { customRender: 'openTime' },
    width: 110
  },
  {
    dataIndex: 'itvCourseName',
    key: 'itvCourseName',
    title: '学习机课程名称',
    scopedSlots: { customRender: 'itvCourseName' },
    width: 120
  },
  {
    title: '学年学期',
    scopedSlots: { customRender: 'semester' },
    width: 80
  },
  {
    title: '期次',
    scopedSlots: { customRender: 'periodStr' },
    width: 80
  },
  {
    scopedSlots: { customRender: 'classCycleStr' },
    title: '周期',
    width: 80
  },
  {
    scopedSlots: { customRender: 'timeIntervalStr' },
    title: '时段',
    width: 50
  },
  {
    title: '操作',
    key: 'actions',
    scopedSlots: { customRender: 'actions' },
    // fixed: 'right',
    width: 50
  }
]
export default {
  mixins: [mixins],
  components: {
    YearSemesterSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    formatTimeStr(record) {
      if (record.beginTime.indexOf('1970') !== -1 ||
      record.beginTime.indexOf('1970') !== -1) {
        return '--'
      }
      return `${moment(record.beginTime).format('YYYY.MM.DD')}-${moment(record.endTime).format('YYYY.MM.DD')}`
    }
  },
  data() {
    return {
      searchGroupName: '',
      searchItvCourseName: '',
      year: '',
      semester: '',
      columns,
      loading: false,
      groupList: [],
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1
      },
      confirmLoading: false,
      scroll: {
        x: 760,
        y: 'calc(100vh - 80px - 54px - 74px - 57px - 68px )'
      },
      hideModalWidth: 1100,
      isChange: false // 是否恢复过隐藏小组，用于通知父组件更新
    }
  },
  mounted() {
    this.getHideGroupList()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      const w = document.documentElement.clientWidth || document.body.clientWidth
      if (w > 1204) {
        this.hideModalWidth = 1100
      } else {
        this.hideModalWidth = 'calc(100% - 80px)'
      }
    },
    updateYearAndSemester(opts) {
      this.year = opts.year === '全部' ? '' : opts.year
      this.semester = opts.semester === '全部' ? '' : opts.semester
    },
    selectionChange(val, key) {
      this.$store.commit(`common/setActive${key}`, val)
    },
    /**
     * 小组搜索
     */
    doSearch() {
      this.pagination.current = 1
      this.getHideGroupList()
    },
    // 重置筛选信息
    doReset() {
      this.searchGroupName = ''
      this.searchItvCourseName = ''
      this.$store.commit(`common/setActivePeriod`, -2)
      this.$store.commit(`common/setActiveTimeInterval`, -1)
      this.$store.commit(`common/setActiveClassCycle`, -1)
      this.activeClassCycle = ''
      this.$refs.yearAndSemesterModle.clearSelect()
      // clearSelect有计算属性，存在时间差，强制重置学年学期
      this.year = ''
      this.semester = ''
      console.log('重置', this.year, this.semester)
      this.doSearch()
    },
    // 翻页
    handleChangePageNum(current, pageSize) {
      console.log('handleChangePageNum', current)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getHideGroupList()
    },
    /**
     * 获取隐藏小组列表
     */
    getHideGroupList() {
      this.loading = true
      const searchParams = {
        hideStatus: 1, // 0未隐藏，1已隐藏
        timeInterval: this.activeTimeInterval || -1,
        classCycle: this.activeClassCycle || -1,
        period: this.activePeriod,
        groupName: (this.searchGroupName).trim(),
        itvCourseName: (this.searchItvCourseName).trim(),
        year: this.year,
        semester: this.semester,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      this.$service.groupManage.getGroupList(searchParams)
        .then(res => {
          this.loading = false
          this.pagination = {
            ...this.pagination,
            total: res.itemTotal,
            current: res.pageNum
          }
          res.list.forEach((item, index) => {
            item.index = this.pagination.total - (this.pagination.current - 1) * this.pagination.pageSize - index
          })
          this.groupList = res.list
        })
        .catch(() => {
          this.loading = false
        })
    },
    /**
     * @description 取消
     */
    handleCancel() {
      this.$emit('update:visible', false)
      this.isChange && this.$emit('updateList')
    },
    // 恢复小组
    handleShowGroup(record) {
      this.$confirm({
        content: '确定恢复该小组吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$service.groupManage.hideGroup({ groupId: record.id, status: 0 }).then(res => {
            this.isChange = true
            this.$message.success('操作成功')
            this.getHideGroupList()
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.hide-group-modal{
  // padding: 10px;
  .filter-selection {
    margin-right: 4px;
  }
  .mr4 {
    margin-right: 4px;
  }
  .ant-modal{
    margin: 40px;
    box-sizing: border-box;
    overflow: auto;
    height: calc(100% - 80px);
    border-radius: 12px;
  }
  .ant-modal-body {
    .select {
      width: 80px;
    }
    .table-filter {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      justify-content: space-between;

      .filter-title {
        margin-right: 12px;
      }

      .filter-title:not(:first-child) {
        margin-left: 20px;
      }
    }
    .pagination {
        text-align: right;
        padding-top: 12px;
      }

    .ant-table-tbody {
      // max-height: calc(100% - 68px);
      // height: calc(100% - 68px);
      // overflow: auto;
      // background: red;
      tr {
        line-height: 32px;
        .text-num{
          display: block;
          text-align: left;
        }
        .text-limit1 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .text-limit {
          padding: 0px 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .text-itv-name {
          position: relative;
          i {
            position: absolute;
            font-size: 10px;
            right: 0;
            top: -11px;
            background: #3262FD;
            border-radius: 0px 0px 0px 4px;
            color: #fff;
            display: inline-block;
            line-height: 1;
            padding: 2px 4px;
          }
        }
      }
      .plan-name {
        min-width: 120px;
      }
    }
  }
}

</style>